<template lang="pug">
div
    h4.titulo-secao(v-if='mostrarTitulo') {{ $t('mensagens.territorio.arquivo.tituloEvidencias') }}
    .card-upload
        .card-header
            i.el-icon-files.header-icon
            .header-text
                h4.header-title {{ $t('mensagens.territorio.arquivo.subTituloEvidencias') }}
        
        .upload-section
            .upload-header
                .upload-label
                    i.el-icon-paperclip
                    span {{ $t('mensagens.territorio.arquivo.evidencia') }}
                .upload-controls
                    el-select.select-tipo-soja-header(
                        v-model='tipoSojaSelecionado',
                        :placeholder='$t("mensagens.territorio.arquivo.selecioneTipoSoja")',
                        size='small',
                        style='margin-right: 12px; width: 150px;'
                    )
                        el-option(
                            label='2BSVS',
                            value='2BSVS',
                            :disabled='jaExisteArquivoTipo("2BSVS")'
                        )
                        el-option(
                            label='EUDR',
                            value='EUDR',
                            :disabled='jaExisteArquivoTipo("EUDR")'
                        )
                    el-upload.upload-action(
                        :show-file-list='false',
                        :on-change='handleChange',
                        action='#',
                        :auto-upload='false',
                        multiple,
                        :disabled='!tipoSojaSelecionado'
                    )
                        el-button.btn-upload(
                            icon='el-icon-upload2',
                            type='primary',
                            size='small',
                            :disabled='!tipoSojaSelecionado'
                        )
                            | {{ $t('mensagens.territorio.arquivo.enviar') }}
            
            el-divider(v-if='arquivosComTipo.length > 0')
            
            .files-list(v-if='arquivosComTipo.length > 0')
                .file-item(v-for='(item, index) in arquivosComTipo', :key='index')
                    .file-icon
                        i.el-icon-document
                    .file-info
                        .file-name
                            el-link.file-link(
                                v-if='item.urlDownload',
                                @click.prevent='downloadFile(item)',
                                :underline='false',
                                :title='item.name || item.nomeArquivo'
                            )
                                | {{ truncateFileName(item.name || item.nomeArquivo) }}
                            span(v-else) {{ truncateFileName(item.name || item.nomeArquivo) }}
                        .file-size {{ item?.arquivo?.fileSize ? item?.arquivo?.fileSize : item?.fileSize ? item?.fileSize : item?.fileSize }}
                    .file-tipo-soja
                        el-tag(
                            :type='item.tipoSoja === "2BSVS" ? "success" : "warning"',
                            size='small',
                            effect='plain'
                        ) {{ item.tipoSoja || '-' }}
                    .file-actions
                        el-button.btn-delete-file(
                            @click='deleteItem(index)',
                            type='text',
                            icon='el-icon-delete',
                            size='small'
                        )
            
            .empty-files(v-else)
                i.el-icon-folder-opened.empty-icon
                p.empty-text {{ $t('mensagens.territorio.arquivo.nenhumArquivo') }}
</template>

<style scoped lang="scss">
.titulo-secao {
    font-weight: 700;
    color: #5a5a5a;
    margin-bottom: 16px;
}

.card-upload {
    background-color: white;
    border-radius: 8px;
    padding: 24px;
    min-height: 195px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #e4e7ed;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 2px solid #f0f2f5;
}

.header-icon {
    font-size: 24px;
    color: var(--primary);
}

.header-text {
    flex: 1;
}

.header-title {
    color: #5a5a5a;
    font-weight: 600;
    font-size: 15px;
    margin: 0;
}

.upload-section {
    width: 100%;
}

.upload-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.upload-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 14px;
    color: #5a5a5a;
    
    i {
        font-size: 18px;
        color: var(--primary);
    }
}

.btn-upload {
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
    
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
        transition: all 0.3s ease;
    }
}

.files-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.file-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: #f8f9fa;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    transition: all 0.3s ease;
    
    &:hover {
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    }
}

.file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #e1f0ff;
    border-radius: 6px;
    flex-shrink: 0;
    
    i {
        font-size: 20px;
        color: var(--primary);
    }
}

.file-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
}

.file-name {
    font-weight: 600;
    font-size: 14px;
    color: #303133;
}

.file-link {
    color: var(--primary);
    font-weight: 600;
    word-break: break-word;
    
    &:hover {
        color: #66b1ff;
    }
}

.file-size {
    font-size: 12px;
    color: #909399;
    font-weight: 500;
}

.file-tipo-soja {
    min-width: 100px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-controls {
    display: flex;
    align-items: center;
}

.file-actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.btn-delete-file {
    color: #f56c6c;
    font-size: 18px;
    padding: 8px;
    
    &:hover {
        color: #dc362e;
        background: rgba(245, 108, 108, 0.1);
        border-radius: 4px;
    }
}

.empty-files {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px 16px;
    text-align: center;
}

.empty-icon {
    font-size: 48px;
    color: #c0c4cc;
    margin-bottom: 12px;
}

.empty-text {
    font-size: 13px;
    color: #909399;
    margin: 0;
    font-weight: 500;
}
</style>

<script>
export default {
    name: 'UploadEvidenciasAr',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        mostrarTitulo: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            arquivosComTipo: [],
            tipoSojaSelecionado: ''
        };
    },
    watch: {
        items: {
            handler(newItems) {
                if (newItems && newItems.length > 0) {
                    this.arquivosComTipo = newItems.map(item => ({
                        ...item,
                        tipoSoja: item.tipoSoja || ''
                    }));
                } else {
                    this.arquivosComTipo = [];
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        handleChange(file) {
            if (!this.tipoSojaSelecionado) {
                this.$notify.warning({
                    message: this.$t('mensagens.territorio.arquivo.selecioneTipoSojaAntes')
                });
                return;
            }
            
            if (this.jaExisteArquivoTipo(this.tipoSojaSelecionado)) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.arquivo.jaExisteArquivoTipo', { tipo: this.tipoSojaSelecionado })
                });
                this.tipoSojaSelecionado = '';
                return;
            }
            
            const url = URL.createObjectURL(file.raw);
            const info = {
                name: file.name,
                fileSize: this.formatFileSize(file.size, 1),
                file: file.raw,
                src: url,
                id: file.uid,
                tipoSoja: this.tipoSojaSelecionado
            };
            this.arquivosComTipo.push(info);
            this.$emit('add', info);
            this.tipoSojaSelecionado = '';
        },
        jaExisteArquivoTipo(tipo) {
            return this.arquivosComTipo.some(arquivo => arquivo.tipoSoja === tipo);
        },
        deleteItem(index) {
            const item = this.arquivosComTipo[index];
            if (item?.urlDownload) {
                this.$emit('before-delete', { index, item });
            } else {
                this.arquivosComTipo.splice(index, 1);
                this.$emit('delete', index);
            }
        },
        truncateFileName(fileName, maxLength = 40) {
            if (!fileName) return '';
            return fileName.length > maxLength ? fileName.substring(0, maxLength) + '...' : fileName;
        },
        formatFileSize(bytes, decimalPoint) {
            if (!bytes || bytes === 0) return '0 Bytes';
            var k = 1000;
            var dm = decimalPoint || 2;
            var sizes = [
                'Bytes',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB',
                'YB'
            ];
            var i = Math.floor(Math.log(bytes) / Math.log(k));
            return (
                parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) +
                ' ' +
                sizes[i]
            );
        },
        downloadFile(item) {
            if (!item.urlDownload) return;
            
            try {
                const link = document.createElement('a');
                link.href = item.urlDownload;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.territorio.arquivo.erroDownload') || 'Erro ao baixar arquivo'
                });
            }
        }
    }
};
</script>
